import styled, { css } from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  position: relative;
  margin-left: -60px;
  width: 330px;
  max-height: 350px;
  min-height: 142px;
  padding: 12px 16px 16px;
  border-radius: 8px;
  box-shadow: 0px 12px 28px rgba(33, 39, 73, 0.2);
  z-index: 10;
  background-color: #fff;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.h2`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 0;
`;

export const Content = styled.h2`
  color: ${beam.font.primary};
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const Icon = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  color: #474d66;
`;

export const Item = styled.div`
  display: flex;
  padding: 8px 0px 8px 8px;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  color: ${beam.font.primary};
  cursor: pointer;

  :hover {
    background-color: #f5f7fb;
    border-radius: 4px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  margin-bottom: 6px;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 16px;
  font-weight: 600;
`;

export const Close = styled.button`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 5px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

interface IText {
  limitOfLines?: number;
}

export const Text = styled.div<IText>`
  text-align: left;
  font-size: 12px;
  font-weight: 500;
  color: #1b203a;

  &.description {
    font-size: 14px;
    font-weight: 300;
    color: #8f95b2;
  }

  &.product-label {
    font-size: 14px;

    margin-bottom: 0;
  }

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const ProductList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;

  &.clear {
    justify-content: flex-end;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 12px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;

  transition: 0.2s;
  :hover {
    background-color: #f5f7fb;
    border-radius: 8px;
  }
`;

export const ProductImage = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 14px;
  border-radius: 4px;
  border: 1px solid #e6e8f0;
`;

export const ManufacturerImage = styled.img`
  height: 14px;
`;

export const Divider = styled.div`
  margin-top: 16px;
`;

export const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
  flex: 1;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const CounterWrapper = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  background-color: #f5f7fb;
  border-radius: 12px;
  font-weight: 600;
  font-size: 12px;
  color: #8f95b2;
  align-items: center;
  justify-content: center;

  margin-left: 4px;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ClearButton = styled.button`
  display: flex;
  border: 0;
  background-color: transparent;
  color: #8f95b2;
  font-size: 12px;
  font-weight: 400;
  padding: 6px;

  transition: 0.2s;
  :hover {
    background-color: #f6f8ff;
    border-radius: 4px;
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  margin-left: 13px;
  border: 0;
  background-color: transparent;
`;
